import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import familyFestApi from '@infrastructure/family-fest-api';
export const generatePassportOtpAsync = createAsyncThunk('familyFestPassport/generateOtp', async (eventId, { rejectWithValue }) => {
    try {
        const response = await familyFestApi.generatePassportOtp(eventId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const verifyPassportOtpAsync = createAsyncThunk('familyFestPassport/verifyOtp', async (otp, { rejectWithValue }) => {
    try {
        const response = await familyFestApi.verifyPassportOtp(otp);
        if (response.data.isSuccess && response.data.data) {
            sessionStorage.setItem('OTPId', response.data.data);
        }
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const fetchFamilyFestPassportsAsync = createAsyncThunk('familyFestPassport/fetchAll', async (query, { rejectWithValue }) => {
    try {
        const otpId = sessionStorage.getItem('OTPId') ?? undefined;
        const response = await familyFestApi.getFamilyFestPassports({ ...query, OTPId: otpId });
        return response.data.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const fetchPassportAuditLogsAsync = createAsyncThunk('familyFestPassport/fetchAuditLogs', async ({ eventId, query }, { rejectWithValue }) => {
    try {
        const response = await familyFestApi.getPassportAuditLogs(eventId, query);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
